import * as tslib_1 from "tslib";
import { Button, Popover } from '@nextiva/next-ui';
import cx from 'classnames';
import find from 'lodash/find';
import moment from 'moment-timezone';
import React, { createRef } from 'react';
import presets, { sortUnits } from '../constants/presets';
import CustomOptions from './CustomOptions/CustomOptions';
import "./DrpPopover.css";
import RelativeOptions from './RelativeOptions/RelativeOptions';

var DrpPopover =
/** @class */
function (_super) {
  tslib_1.__extends(DrpPopover, _super);

  function DrpPopover() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      isOpen: _this.props.isOpen || false
    };
    _this.bodyRef = createRef();

    _this.togglePopover = function () {
      if (_this.props.disabled) {
        return null;
      }

      _this.setState(function (state) {
        return {
          isOpen: !state.isOpen
        };
      });
    };

    return _this;
  }

  DrpPopover.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      this.setState({
        isOpen: Boolean(this.props.isOpen)
      });
    }
  };

  DrpPopover.prototype.render = function () {
    var isOpen = this.state.isOpen;
    return React.createElement(Popover, {
      className: cx('drp-popover', this.props.className),
      body: React.createElement(DrpPopoverBody, tslib_1.__assign({
        ref: this.bodyRef,
        togglePopover: this.togglePopover
      }, this.props)),
      isOpen: isOpen,
      togglePopover: this.togglePopover,
      clickOutsideIgnoreClasses: ['react-datepicker']
    }, this.props.children);
  };

  DrpPopover.defaultProps = {
    presets: presets,
    relativeUnits: sortUnits
  };
  return DrpPopover;
}(React.Component);

var DrpPopoverBody =
/** @class */
function (_super) {
  tslib_1.__extends(DrpPopoverBody, _super);

  function DrpPopoverBody() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      dateRange: _this.getFullDateRange(_this.props.dateRange)
    };

    _this.handleChangeDateRangeType = function (type) {
      return function () {
        var _a = _this.props,
            dateRange = _a.dateRange,
            timezone = _a.timezone;

        if (type === dateRange.type) {
          _this.setState({
            dateRange: dateRange
          });
        } else {
          if (type === 'relative') {
            _this.setState({
              dateRange: tslib_1.__assign({
                type: 'relative'
              }, _this.findFirstPreset(_this.props.presets, _this.props.relativeUnits))
            });
          } else {
            _this.setState({
              dateRange: {
                type: 'absolute',
                start: moment.tz(timezone).startOf('day').toISOString(),
                end: moment.tz(timezone).toISOString()
              }
            });
          }
        }
      };
    };

    _this.handleChange = function (dateRange) {
      var _a = _this.props,
          onChange = _a.onChange,
          togglePopover = _a.togglePopover;

      if (onChange) {
        onChange(dateRange);
      }

      togglePopover();
    };

    return _this;
  }

  DrpPopoverBody.prototype.componentWillReceiveProps = function (nextProps) {
    if (this.props.dateRange !== nextProps.dateRange) {
      this.setState({
        dateRange: this.getFullDateRange(nextProps.dateRange)
      });
    }
  };

  DrpPopoverBody.prototype.getFullDateRange = function (dateRange) {
    if (dateRange.type !== 'relative') {
      dateRange = tslib_1.__assign({
        type: 'absolute'
      }, dateRange);
    }

    return dateRange;
  };

  DrpPopoverBody.prototype.findFirstPreset = function (dateRangePickerPresets, relativeUnits) {
    var firstPreset = dateRangePickerPresets.Today;
    relativeUnits.some(function (unit) {
      var preset = find(dateRangePickerPresets, {
        unit: unit
      });

      if (preset) {
        firstPreset = preset;
        return true;
      }

      return false;
    });
    return firstPreset;
  };

  DrpPopoverBody.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        timezone = _a.timezone,
        isPeriod = _a.isPeriod,
        isRealTime = _a.isRealTime,
        onChangeCancel = _a.onChangeCancel,
        relativeUnits = _a.relativeUnits;
    var dateRange = this.state.dateRange;
    return React.createElement("div", {
      className: cx(className, 'drp-popover__body')
    }, !isPeriod && React.createElement("div", {
      className: "drp-popover__buttons"
    }, React.createElement(Button, {
      className: cx('drp-popover__relative-button', 'drp-popover__button', {
        'drp-popover__button--active': dateRange.type === 'relative'
      }),
      onClick: this.handleChangeDateRangeType('relative')
    }, "Relative"), React.createElement(Button, {
      className: cx('drp-popover__custom-button', 'drp-popover__button', {
        'drp-popover__button--active': dateRange.type === 'absolute'
      }),
      onClick: this.handleChangeDateRangeType('absolute')
    }, "Custom")), dateRange.type === 'relative' ? React.createElement(RelativeOptions, tslib_1.__assign({}, dateRange, {
      presets: this.props.presets,
      timezone: timezone,
      units: relativeUnits,
      onSave: this.handleChange
    })) : React.createElement(CustomOptions, tslib_1.__assign({}, dateRange, {
      timezone: timezone,
      hideEnd: isRealTime,
      onSave: this.handleChange,
      onSaveCancel: onChangeCancel
    })));
  };

  return DrpPopoverBody;
}(React.Component);

export default DrpPopover;